import React, { useEffect, useRef, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import TopHeader from "../../Components/TopHeader";
import Prince from "../../Components/Prince";

import * as caseService from "../../Services/caseService";

import Loader from "../../assets/img/loader.gif";

import { io } from "socket.io-client";
import { toast } from "react-toastify";

// const API_URL =
//   process.env.REACT_APP_API_URL ||
//   "http://localhost:2000";

// const API_URL = process.env.REACT_APP_URL;

// const socket = io(API_URL, {
//   transports: ["polling"],
// });

// const API_URL = process.env.REACT_APP_URL;

// const socket = io(API_URL, {
//   transports: [ "websocket"], //  Polling hata kar sirf websocket karein
//   upgrade: false,            //  Direct WebSocket connect karne ke liye
// });

const API_URL = process.env.REACT_APP_URL;

const socket = io(API_URL, {
  transports: ["polling"],
  upgrade: false,
  autoConnect: false,
});

export const B2BCasesActivity = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const previousTab = location.state?.previousTab;
  const previousFilters = location.state?.filters || {};
  const previousSubTab = location.state?.previousSubTab || "";

  const { caseId } = location.state || {};
  const [caseData, setCaseData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState("");
  const [chatLoading, setChatLoading] = useState(false);
  const [chatSending, setChatSending] = useState(false);
  const [chatFile, setChatFile] = useState(null);
  const [selectedEmoji, setSelectedEmoji] = useState("");
  const fileInputRef = useRef(null);
  const chatFileInputRef = useRef(null);
  const chatMessagesRef = useRef(null);

  const [emailCc, setEmailCc] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [emailSending, setEmailSending] = useState(false);
  const [emailHistory, setEmailHistory] = useState([]);
  const [emailHistoryLoading, setEmailHistoryLoading] = useState(false);

  const emailFileInputRef = useRef(null);

  const reqEmployeeId = Number(localStorage.getItem("employeeId"));

  useEffect(() => {
    if (!caseId) {
      return;
    }

    getCaseData();
    getCaseChat();
    getEmailHistory();
  }, [caseId]);

  useEffect(() => {
    if (!caseId) {
      return;
    }

    const numericCaseId = Number(caseId);

    const handleNewChat = (newChat) => {
      console.log("Socket New Chat:", newChat);

      if (Number(newChat?.casesMId) !== numericCaseId) {
        return;
      }

      setChatMessages((previousMessages) => {
        const alreadyExists = previousMessages.some(
          (item) => Number(item.id) === Number(newChat.id),
        );

        if (alreadyExists) {
          return previousMessages;
        }

        return [...previousMessages, newChat];
      });
    };

    const handleConnect = () => {
      console.log("Case chat socket connected:", socket.id);

      socket.emit("joinCaseChat", {
        caseId: numericCaseId,
      });
    };

    const handleConnectError = (error) => {
      console.error("Case chat socket error:", error?.message || error);
    };

    socket.on("connect", handleConnect);
    socket.on("connect_error", handleConnectError);
    socket.on("newCaseChat", handleNewChat);

    // IMPORTANT
    if (!socket.connected) {
      socket.connect();
    } else {
      socket.emit("joinCaseChat", {
        caseId: numericCaseId,
      });
    }

    return () => {
      socket.emit("leaveCaseChat", {
        caseId: numericCaseId,
      });

      socket.off("connect", handleConnect);
      socket.off("connect_error", handleConnectError);
      socket.off("newCaseChat", handleNewChat);
    };
  }, [caseId]);

  useEffect(() => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
    }
  }, [chatMessages]);

  const formatChatDate = (dateString) => {
    if (!dateString) {
      return "";
    }

    const date = new Date(dateString);

    if (Number.isNaN(date.getTime())) {
      return "";
    }

    const today = new Date();

    const yesterday = new Date();

    yesterday.setDate(today.getDate() - 1);

    const isSameDay = (date1, date2) => {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    };

    if (isSameDay(date, today)) {
      return "Today";
    }

    if (isSameDay(date, yesterday)) {
      return "Yesterday";
    }

    return date.toLocaleDateString("en-IN", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const formatChatTime = (dateString, timeString) => {
    let date;

    if (dateString && timeString) {
      date = new Date(`${dateString}T${timeString}`);
    } else {
      date = new Date(dateString);
    }

    if (Number.isNaN(date.getTime())) {
      return timeString || "";
    }

    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getCaseChat = async () => {
    if (!caseId) {
      return;
    }

    try {
      setChatLoading(true);

      const response = await caseService.getCaseChat(caseId);

      if (response?.data?.status === "success") {
        setChatMessages(response.data.data || []);
      } else {
        setChatMessages([]);
      }
    } catch (error) {
      console.error("Get Case Chat Error:", error);

      setChatMessages([]);
    } finally {
      setChatLoading(false);
    }
  };

  // const handleChatFileChange = (e) => {
  //   const file = e.target.files?.[0];

  //   if (!file) return;

  //   setChatFile(file);

  //   // Same file dobara select karne ke liye
  //   e.target.value = "";
  // };

  const handleChatFileChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const MAX_SIZE = 10 * 1024 * 1024; // 10 MB

    if (file.size > MAX_SIZE) {
      toast.error("File size must be less than 10 MB");

      e.target.value = "";
      return;
    }

    setChatFile(file);
  };

  const removeChatFile = () => {
    setChatFile(null);
    if (chatFileInputRef.current) {
      chatFileInputRef.current.value = "";
    }
  };

  const handleEmojiClick = (emoji) => {
    setSelectedEmoji(emoji);

    setChatInput((previous) => previous + emoji);
  };

  const handleSendChat = async () => {
    const message = chatInput.trim();

    if (!caseId) {
      return;
    }

    // Nothing to send
    if (!message && !chatFile) {
      return;
    }

    try {
      setChatSending(true);

      const formData = new FormData();

      formData.append("casesMId", String(caseId));

      if (message) {
        formData.append("message", message);
      }

      if (chatFile) {
        formData.append("attachment", chatFile);
      }

      let chatType = "TEXT";

      if (chatFile) {
        if (chatFile.type?.startsWith("image/")) {
          chatType = "IMAGE";
        } else {
          chatType = "FILE";
        }
      }

      formData.append("type", chatType);

      if (selectedEmoji) {
        formData.append("emoji", selectedEmoji);
      }
      // console.log(
      //   "========== SEND CHAT =========="
      // );

      for (const [key, value] of formData.entries()) {
        console.log(key, value instanceof File ? value.name : value);
      }

      const response = await caseService.sendCaseChat(formData);

      if (response?.data?.status === "success") {
        setChatInput("");

        setChatFile(null);

        setSelectedEmoji("");

        if (chatFileInputRef.current) {
          chatFileInputRef.current.value = "";
        }

        // Refresh chat
        await getCaseChat();
      }
    } catch (error) {
      console.error("Send Chat Error:", error?.response?.data || error);
    } finally {
      setChatSending(false);
    }
  };

  const getCaseData = async () => {
    try {
      setLoader(true);

      const response = await caseService.b2bactivitycase(caseId);

      if (response?.data?.status === "success") {
        setCaseData(response.data.data);
      }
    } catch (error) {
      console.log("B2B Activity Case Error:", error);
    } finally {
      setLoader(false);
    }
  };

  // useEffect(() => {
  //   if (!caseData?.caseEmail?.length) {
  //     return;
  //   }

  //   const ccEmails = caseData.caseEmail
  //     .map((email) => email?.ccEmail)
  //     .filter(Boolean)
  //     .join(", ");

  //   const subjects = caseData.caseEmail
  //     .map((email) => email?.subject)
  //     .filter(Boolean)
  //     .join(", ");

  //   setEmailCc(ccEmails);
  //   setEmailSubject(subjects);
  // }, [caseData]);

  useEffect(() => {
    if (!caseData?.caseEmail?.length) {
      return;
    }

    const latestEmail = caseData.caseEmail[caseData.caseEmail.length - 1];

    setEmailCc(latestEmail?.ccEmail || "");
    setEmailSubject(latestEmail?.subject || "");
  }, [caseData]);

  const assignedEmployee =
    caseData?.EmployeeCasesM?.length > 0
      ? caseData.EmployeeCasesM[0]?.employee
      : null;

  const employeeName = assignedEmployee
    ? `${assignedEmployee.firstName || ""} ${
        assignedEmployee.lastName || ""
      }`.trim()
    : "-";

  const employeeEmail = assignedEmployee?.email || "-";

  const employeeMobile =
    assignedEmployee?.mobileNumber || assignedEmployee?.phoneNumber || "-";

  const customer = caseData?.customer;

  const customerName = customer?.primaryContactName || customer?.name || "-";

  const customerCompany = customer?.companyName || "-";

  const customerEmail = customer?.emailId || "-";

  const customerPhone =
    customer?.phoneNumber ||
    customer?.mobileNumber ||
    customer?.phone ||
    caseData?.alternateNumber ||
    "-";

  const caseType =
    caseData?.caseType?.name ||
    caseData?.caseTypeName ||
    caseData?.caseTypeId ||
    "-";

  const caseSubType =
    caseData?.caseSubType?.name ||
    caseData?.caseSubTypeName ||
    caseData?.caseSubTypeId ||
    "-";

  const InfoItem = ({ label, value, children, fullWidth = false }) => {
    const hasValue = value !== null && value !== undefined && value !== "";

    const hasChildren =
      children !== null && children !== undefined && children !== "";

    if (!hasValue && !hasChildren) {
      return null;
    }

    return (
      <div className={fullWidth ? "col-12" : "col-md-4"}>
        <div className="case-info-item">
          <div className="case-info-label">{label}</div>

          <div className="case-info-value">
            {hasChildren ? children : value}
          </div>
        </div>
      </div>
    );
  };

  const renderAwb = () => {
    if (!caseData?.awbNo?.length) {
      return "No AWB";
    }

    if (caseData.awbNo.length === 1) {
      const awb = caseData.awbNo[0];

      return awb?.awbNumber || awb?.awbNo || awb?.number || "-";
    }

    return (
      <button type="button" className="case-link">
        {caseData.awbNo.length} AWBs - View
      </button>
    );
  };

  const renderOrderId = () => {
    if (!caseData?.orderId?.length) {
      return "No Order ID";
    }

    if (caseData.orderId.length === 1) {
      const order = caseData.orderId[0];

      return order?.orderId || order?.id || "-";
    }

    return (
      <button type="button" className="case-link">
        {caseData.orderId.length} Orders - View
      </button>
    );
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];

    if (file) {
      setSelectedFile(file);
    }
  };

  const handleSendEmail = async () => {
    try {
      if (!caseId) {
        toast.error("Case ID not found.");
        return;
      }

      if (!emailSubject.trim()) {
        toast.error("Please enter subject.");
        return;
      }

      if (!emailMessage.trim()) {
        toast.error("Please enter message.");
        return;
      }

      const receiverEmail = customer?.emailId || "";

      if (!receiverEmail) {
        toast.error("Customer email not found.");
        return;
      }

      setEmailSending(true);

      const formData = new FormData();

      formData.append("subject", emailSubject.trim());

      formData.append("message", emailMessage.trim());

      formData.append("receiverEmail", receiverEmail);

      formData.append("ccEmail", emailCc.trim());

      if (selectedFile) {
        formData.append("uploadedFile", selectedFile);
      }

      const response = await caseService.sendEmail(caseId, formData);

      if (response?.data?.status === "success") {
        toast.success("Email sent successfully.");

        // setEmailCc("");
        // setEmailSubject("");
        setEmailMessage("");
        setSelectedFile(null);

        if (emailFileInputRef.current) {
          emailFileInputRef.current.value = "";

          // Refresh email history immediately after sending
          await getEmailHistory();
        }
      } else {
        toast.error(response?.data?.message || "Failed to send email.");
      }
    } catch (error) {
      // console.error(
      //   "SEND EMAIL ERROR:",
      //   error
      // );

      toast.error(error?.response?.data?.message || "Failed to send email.");
    } finally {
      setEmailSending(false);
    }
  };

  const getEmailHistory = async () => {
    if (!caseId) return;

    try {
      setEmailHistoryLoading(true);

      const response = await caseService.getCaseEmail(caseId);

      if (response?.data?.status === "success") {
        setEmailHistory(response?.data?.data || []);
      } else {
        setEmailHistory([]);
      }
    } catch (error) {
      console.error("Get case email error:", error);
      setEmailHistory([]);
    } finally {
      setEmailHistoryLoading(false);
    }
  };

  const handleChatPaste = (e) => {
    const items = e.clipboardData?.items;

    if (!items) return;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.kind === "file") {
        const file = item.getAsFile();

        if (file) {
          e.preventDefault();

          setChatFile(file);
          return;
        }
      }
    }
  };

  const handleChatDrop = (e) => {
    e.preventDefault();

    const files = e.dataTransfer?.files;

    if (!files || files.length === 0) return;

    const file = files[0];

    setChatFile(file);
  };

  return (
    <div className="page">
      <TopHeader />

      <Prince />

      <div className="main-content pt-0">
        <div className="container-fluid py-4">
          {loader ? (
            <div className="loading-overlay">
              <img src={Loader} alt="Loading..." />
            </div>
          ) : (
            <div className="activity-wrapper">
              <header className="support-header">
                <div className="support-header-left">
                  <h4>Support/NDR ID: {caseData?.id || "-"}</h4>
                </div>

                <div className="case-header-badges">
                  <span className="case-badge account">
                    <i className="fas fa-building"></i>
                    {caseData?.accountType || "B2B"}
                  </span>

                  <button
                    type="button"
                    className="btn btn-sm btn-light px-4 d-flex align-items-center"
                    // onClick={() => window.history.back()}
                    onClick={() => {
                      navigate("/b2b/cases", {
                        state: {
                          activeTab: location.state?.previousTab || "New",
                          activeSubTab: location.state?.previousSubTab || "",
                          filters: location.state?.filters || {},
                          // filters: previousFilters,
                        },
                      });
                    }}
                  >
                    <i className="fa fa-arrow-left me-2"></i>
                    Back
                  </button>
                </div>
              </header>

              <div className="row g-3 mt-1">
                <div className="col-lg-6">
                  <div className="person-card">
                    <div className="person-icon employee-icon">
                      <i className="fas fa-user-tie"></i>
                    </div>

                    <div className="person-content">
                      <div className="person-title">Assigned Employee</div>

                      <h5>{employeeName}</h5>

                      <div className="person-meta">
                        {employeeEmail !== "-" && (
                          <span>
                            <i className="fas fa-envelope"></i>

                            {employeeEmail}
                          </span>
                        )}

                        {employeeMobile !== "-" && (
                          <span>
                            <i className="fas fa-phone"></i>

                            {employeeMobile}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="person-card">
                    <div className="person-icon customer-icon">
                      <i className="fas fa-user"></i>
                    </div>

                    <div className="person-content">
                      <div className="person-title">Customer</div>

                      <h5>{customerName}</h5>

                      <div className="person-company">{customerCompany}</div>

                      <div className="person-meta">
                        {customerEmail !== "-" && (
                          <span>
                            <i className="fas fa-envelope"></i>

                            {customerEmail}
                          </span>
                        )}

                        {customerPhone !== "-" && (
                          <span>
                            <i className="fas fa-phone"></i>

                            {customerPhone}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="case-details-card mt-3">
                <div className="section-main-header">
                  <div>
                    <h5>Case Details</h5>

                    <span>Case information & related details</span>
                  </div>

                  <span className="case-id">#{caseData?.id || "-"}</span>
                </div>

                {/* Shipment */}

                <div className="detail-section awb-section">
                  <div className="detail-section-title">
                    <div className="section-title-icon shipment-icon">
                      <i className="fas fa-barcode"></i>
                    </div>

                    <div>
                      <div className="section-heading">Shipment Details</div>

                      <div className="section-subheading">
                        AWB and order information
                      </div>
                    </div>
                  </div>

                  <div className="row g-2">
                    <InfoItem label="AWB No">
                      <div className="awb-value">
                        <i className="fas fa-barcode"></i>

                        <span>{renderAwb()}</span>
                      </div>
                    </InfoItem>

                    <InfoItem label="Order ID">
                      <div className="awb-value">
                        <i className="fas fa-receipt"></i>

                        <span>{renderOrderId()}</span>
                      </div>
                    </InfoItem>

                    <InfoItem
                      label="Invoice Number"
                      value={caseData?.invoiceNumber}
                    />
                  </div>
                </div>

                {/* Basic */}

                <div className="detail-section">
                  <div className="detail-section-title">
                    <div className="section-title-icon basic-icon">
                      <i className="fas fa-info-circle"></i>
                    </div>

                    <div>
                      <div className="section-heading">Basic Information</div>

                      <div className="section-subheading">
                        Case category and issue information
                      </div>
                    </div>
                  </div>

                  <div className="row g-2">
                    <InfoItem label="Category" value={caseType} />

                    <InfoItem label="Sub Category" value={caseSubType} />

                    <InfoItem label="Issue" value={caseData?.selectIssue} />

                    <InfoItem label="Reason" value={caseData?.selectReason} />

                    <InfoItem label="Channel" value={caseData?.selectChannel} />

                    <InfoItem
                      label="Order Type"
                      value={caseData?.selectOrderType}
                    />
                  </div>
                </div>

                {/* Payment */}

                {(caseData?.beneficiaryName ||
                  caseData?.beneficiaryAccountNumber ||
                  caseData?.beneficiaryIfscCode ||
                  caseData?.transactionID) && (
                  <div className="detail-section">
                    <div className="detail-section-title">
                      <div className="section-title-icon payment-icon">
                        <i className="fas fa-credit-card"></i>
                      </div>

                      <div>
                        <div className="section-heading">Payment Details</div>

                        <div className="section-subheading">
                          Beneficiary and transaction information
                        </div>
                      </div>
                    </div>

                    <div className="row g-2">
                      <InfoItem
                        label="Beneficiary Name"
                        value={caseData?.beneficiaryName}
                      />

                      <InfoItem
                        label="Account Number"
                        value={caseData?.beneficiaryAccountNumber}
                      />

                      <InfoItem
                        label="IFSC Code"
                        value={caseData?.beneficiaryIfscCode}
                      />

                      <InfoItem
                        label="Transaction ID"
                        value={caseData?.transactionID}
                      />
                    </div>
                  </div>
                )}

                {/* Issue */}

                {(caseData?.relatedIssue ||
                  caseData?.issuePlatform ||
                  caseData?.companyType ||
                  caseData?.timePeriod ||
                  caseData?.receivedIncorrectInvoice ||
                  caseData?.incorrectMissingCompanyName ||
                  caseData?.incorrectMissingCompanyAddress ||
                  caseData?.incorrectMissingGSTIN) && (
                  <div className="detail-section">
                    <div className="detail-section-title">
                      <div className="section-title-icon issue-icon">
                        <i className="fas fa-exclamation-triangle"></i>
                      </div>

                      <div>
                        <div className="section-heading">Issue Details</div>

                        <div className="section-subheading">
                          Additional issue related information
                        </div>
                      </div>
                    </div>

                    <div className="row g-2">
                      <InfoItem
                        label="Related Issue"
                        value={caseData?.relatedIssue}
                      />

                      <InfoItem
                        label="Platform Issue"
                        value={caseData?.issuePlatform}
                      />

                      <InfoItem
                        label="Company Type"
                        value={caseData?.companyType}
                      />

                      <InfoItem
                        label="Time Period"
                        value={caseData?.timePeriod}
                      />

                      <InfoItem
                        label="Received Incorrect Invoice"
                        value={caseData?.receivedIncorrectInvoice}
                      />

                      <InfoItem
                        label="Missing Company Name"
                        value={caseData?.incorrectMissingCompanyName}
                      />

                      <InfoItem
                        label="Missing Company Address"
                        value={caseData?.incorrectMissingCompanyAddress}
                      />

                      <InfoItem
                        label="Missing GSTIN"
                        value={caseData?.incorrectMissingGSTIN}
                      />
                    </div>
                  </div>
                )}

                {/* Description */}

                {(caseData?.discriptionIssue ||
                  caseData?.otherIssueDescribe ||
                  caseData?.otherIssue ||
                  caseData?.others) && (
                  <div className="detail-section">
                    <div className="detail-section-title">
                      <div className="section-title-icon description-icon">
                        <i className="fas fa-align-left"></i>
                      </div>

                      <div>
                        <div className="section-heading">Remark</div>

                        <div className="section-subheading">
                          Customer provided details
                        </div>
                      </div>
                    </div>

                    <div className="description-list">
                      {caseData?.discriptionIssue && (
                        <div className="description-item">
                          <span>Description</span>

                          <p>{caseData.discriptionIssue}</p>
                        </div>
                      )}

                      {caseData?.otherIssueDescribe && (
                        <div className="description-item">
                          <span>Other Issue Description</span>

                          <p>{caseData.otherIssueDescribe}</p>
                        </div>
                      )}

                      {caseData?.otherIssue && (
                        <div className="description-item">
                          <span>Other Issue</span>

                          <p>{caseData.otherIssue}</p>
                        </div>
                      )}

                      {caseData?.others && (
                        <div className="description-item">
                          <span>Other</span>

                          <p>{caseData.others}</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Existing Attachments */}

                {(caseData?.uploadImage ||
                  caseData?.catelogProductImage ||
                  caseData?.preshippingVideo ||
                  caseData?.unboxVideo ||
                  caseData?.zipFile) && (
                  <div className="detail-section">
                    <div className="detail-section-title">
                      <div className="section-title-icon attachment-icon">
                        <i className="fas fa-paperclip"></i>
                      </div>

                      <div>
                        <div className="section-heading">Attachments</div>

                        <div className="section-subheading">
                          Files and supporting documents
                        </div>
                      </div>
                    </div>

                    <div className="attachment-list">
                      {caseData?.uploadImage && (
                        <a
                          href={caseData.uploadImage}
                          target="_blank"
                          rel="noreferrer"
                          className="attachment-btn"
                        >
                          <i className="fas fa-image"></i>
                          View Image
                        </a>
                      )}

                      {caseData?.catelogProductImage && (
                        <a
                          href={caseData.catelogProductImage}
                          target="_blank"
                          rel="noreferrer"
                          className="attachment-btn"
                        >
                          <i className="fas fa-image"></i>
                          Product Image
                        </a>
                      )}

                      {caseData?.preshippingVideo && (
                        <a
                          href={caseData.preshippingVideo}
                          target="_blank"
                          rel="noreferrer"
                          className="attachment-btn"
                        >
                          <i className="fas fa-video"></i>
                          Pre Shipping Video
                        </a>
                      )}

                      {caseData?.unboxVideo && (
                        <a
                          href={caseData.unboxVideo}
                          target="_blank"
                          rel="noreferrer"
                          className="attachment-btn"
                        >
                          <i className="fas fa-video"></i>
                          Unbox Video
                        </a>
                      )}

                      {caseData?.zipFile && (
                        <a
                          href={caseData.zipFile}
                          target="_blank"
                          rel="noreferrer"
                          className="attachment-btn"
                        >
                          <i className="fas fa-file-archive"></i>
                          ZIP File
                        </a>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="row g-3 mt-1">
                <div className="col-lg-6">
                  <div className="communication-card mb-2">
                    <div className="communication-header">
                      <div>
                        <h5>
                          <i className="fas fa-envelope"></i>
                          Compose Email
                        </h5>

                        <span>Send email to customer</span>
                      </div>
                    </div>

                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleSendEmail();
                      }}
                    >
                      <input
                        type="email"
                        placeholder="To"
                        value={customer?.emailId || ""}
                        readOnly
                      />
                      {/* <input
                        type="text"
                        placeholder="Cc"
                        // value={caseData?.caseEmail?.[0]?.ccEmail || ""}
                        value={
                          caseData?.caseEmail
                            ?.map((email) => email?.ccEmail)
                            .filter(Boolean)
                            .join(", ") || ""
                        }
                        onChange={(e) =>
                          setEmailCc(e.target.value)
                        }
                      /> */}

                      {/* <input
                        type="text"
                        placeholder="Subject"
                        // value={emailSubject}
                        value={
                          caseData?.caseEmail?.map((subject) => subject?.subject)
                        }
                        onChange={(e) =>
                          setEmailSubject(
                            e.target.value
                          )
                        }
                      /> */}

                      <input
                        type="text"
                        placeholder="Cc"
                        value={emailCc}
                        onChange={(e) => setEmailCc(e.target.value)}
                      />

                      <input
                        type="text"
                        placeholder="Subject"
                        value={emailSubject}
                        onChange={(e) => setEmailSubject(e.target.value)}
                      />

                      <textarea
                        placeholder="Start writing..."
                        rows="6"
                        value={emailMessage}
                        onChange={(e) => setEmailMessage(e.target.value)}
                      />

                      <div className="communication-actions">
                        <label className="file-upload-btn">
                          <i className="fas fa-paperclip"></i>

                          <span>
                            {selectedFile ? selectedFile.name : "Attach File"}
                          </span>

                          <input
                            ref={emailFileInputRef}
                            type="file"
                            hidden
                            onChange={handleFileChange}
                          />
                        </label>

                        <button
                          type="submit"
                          className="email-send-btn"
                          disabled={
                            emailSending ||
                            previousTab === "New" ||
                            previousTab === "All"
                          }
                        >
                          {emailSending ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-1"></span>

                              <span>Sending...</span>
                            </>
                          ) : (
                            <>
                              <i className="fas fa-paper-plane"></i>

                              <span>Send</span>
                            </>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="communication-card">
                    {/* HEADER */}
                    <div className="communication-header">
                      <div>
                        <h5>
                          <i className="fas fa-comments"></i>
                          Internal Chat
                        </h5>

                        <span>Internal team communication</span>
                      </div>
                    </div>

                    {/* CHAT BOX */}
                    <div className="chat-box" ref={chatMessagesRef}>
                      {chatLoading ? (
                        <div className="empty-chat">
                          <div className="spinner-border spinner-border-sm"></div>

                          <div>Loading chat...</div>
                        </div>
                      ) : chatMessages.length === 0 ? (
                        <div className="empty-chat">
                          <div className="empty-chat-icon">
                            <i className="fas fa-comments"></i>
                          </div>

                          <div>No chat activity available</div>
                        </div>
                      ) : (
                        <div className="chat-messages">
                          {chatMessages.map((chat, index) => {
                            const employeeName = chat.employee
                              ? `${chat.employee.firstName || ""} ${
                                  chat.employee.lastName || ""
                                }`.trim()
                              : "Unknown";

                            const chatDate =
                              chat.createdAtDate && chat.createdAtTime
                                ? `${chat.createdAtDate}T${chat.createdAtTime}`
                                : chat.createdAt;

                            const currentDate = formatChatDate(chatDate);

                            const previousChat = chatMessages[index - 1];

                            const previousChatDate = previousChat
                              ? previousChat.createdAtDate &&
                                previousChat.createdAtTime
                                ? `${previousChat.createdAtDate}T${previousChat.createdAtTime}`
                                : previousChat.createdAt
                              : null;

                            const previousDate = previousChatDate
                              ? formatChatDate(previousChatDate)
                              : null;

                            const showDateSeparator =
                              index === 0 || currentDate !== previousDate;

                            const isMine =
                              Number(chat.createdBy) === Number(reqEmployeeId);

                            const attachmentUrl = chat.attachment
                              ? `${process.env.REACT_APP_URL}/${chat.attachment.replace(/^public\//, "")}`
                              : null;

                            return (
                              <React.Fragment key={chat.id || `chat-${index}`}>
                                {/* DATE */}
                                {showDateSeparator && (
                                  <div className="chat-date-separator">
                                    <span>{currentDate}</span>
                                  </div>
                                )}

                                {/* MESSAGE */}
                                <div
                                  className={`chat-message-row ${
                                    isMine ? "sent" : "received"
                                  }`}
                                >
                                  <div className="chat-message-bubble">
                                    {/* SENDER */}
                                    {!isMine && (
                                      <div className="chat-sender-name">
                                        {employeeName}
                                      </div>
                                    )}

                                    {/* TEXT */}
                                    {chat.message && (
                                      <div className="chat-message-text">
                                        {chat.message}
                                      </div>
                                    )}

                                    {/* EMOJI */}
                                    {chat.emoji && (
                                      <div className="chat-message-emoji">
                                        {chat.emoji}
                                      </div>
                                    )}

                                    {/* ATTACHMENT */}
                                    {/* ATTACHMENT */}
                                    {chat.attachment && (
                                      <div className="chat-message-attachment">
                                        {chat.type?.toLowerCase() ===
                                        "image" ? (
                                          <img
                                            src={attachmentUrl}
                                            alt="Chat"
                                            className="chat-message-image"
                                            onClick={() => {
                                              window.open(
                                                attachmentUrl,
                                                "_blank",
                                              );
                                            }}
                                          />
                                        ) : (
                                          <a
                                            href={attachmentUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="chat-message-file"
                                          >
                                            <i className="fas fa-file"></i>

                                            <span>Open File</span>
                                          </a>
                                        )}
                                      </div>
                                    )}

                                    {/* TIME */}
                                    <div className="chat-message-time">
                                      {formatChatTime(
                                        chat.createdAtDate,
                                        chat.createdAtTime,
                                      )}

                                      {isMine && (
                                        <i className="fas fa-check-double chat-read-icon"></i>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          })}
                        </div>
                      )}
                    </div>

                    {/* CHAT INPUT */}
                    <div className="chat-input">
                      {/* INPUT */}
                      <input
                        type="text"
                        placeholder={chatFile ? "" : "Type your message..."}
                        value={
                          chatFile
                            ? `📎 ${chatFile.name}${
                                chatInput ? `  ${chatInput}` : ""
                              }`
                            : chatInput
                        }
                        onChange={(e) => {
                          let value = e.target.value;

                          if (chatFile) {
                            const filePrefix = `📎 ${chatFile.name}`;

                            if (value.startsWith(filePrefix)) {
                              value = value
                                .slice(filePrefix.length)
                                .trimStart();
                            } else {
                              value = value.replace(/^📎\s*/, "");
                            }
                          }

                          setChatInput(value);
                        }}
                        /* COPY IMAGE/FILE -> CTRL + V */
                        onPaste={handleChatPaste}
                        /* DRAG */
                        onDragOver={(e) => {
                          e.preventDefault();
                        }}
                        /* DROP */
                        onDrop={handleChatDrop}
                        /* ENTER SEND */
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();

                            handleSendChat();
                          }
                        }}
                      />

                      {/* FILE / REMOVE FILE BUTTON */}
                      <button
                        type="button"
                        className="attach-btn"
                        onClick={() => {
                          if (chatFile) {
                            // File already selected
                            // Click = remove file
                            removeChatFile();
                          } else {
                            // No file selected
                            // Click = open file picker
                            chatFileInputRef.current?.click();
                          }
                        }}
                        title={chatFile ? "Remove attachment" : "Attach file"}
                      >
                        <i
                          className={
                            chatFile ? "fas fa-times" : "fas fa-paperclip"
                          }
                        ></i>

                        <input
                          ref={chatFileInputRef}
                          type="file"
                          accept="image/*, .pdf, .xlsx, .xls, .zip, .7z, .tar, .mp4, .mov"
                          hidden
                          onChange={handleChatFileChange}
                        />
                      </button>

                      {/* SEND */}
                      <button
                        type="button"
                        className="chat-send-btn"
                        onClick={handleSendChat}
                        disabled={
                          chatSending || (!chatInput.trim() && !chatFile)
                        }
                      >
                        {chatSending ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-1"></span>
                            Sending...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-paper-plane"></i>
                            Send
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {!emailHistoryLoading && emailHistory?.length > 0 && (
                <div className="row g-3 mt-1">
                  <div className="col-12">
                    <div className="communication-card email-history-card">
                      {/* HEADER */}

                      <div className="email-history-header">
                        <div>
                          <h5 className="mb-1">
                            <i className="fas fa-history me-2"></i>
                            Email History
                          </h5>

                          <span>Previous emails sent for this case</span>
                        </div>

                        <span className="email-count">
                          {emailHistory.length}
                        </span>
                      </div>

                      {/* EMAIL LIST */}

                      <div className="email-history-list">
                        {emailHistory.map((email, index) => (
                          <div
                            className="email-history-item"
                            key={email.id || index}
                          >
                            <div className="email-history-top">
                              <div className="email-history-icon">
                                <i className="fas fa-envelope"></i>
                              </div>

                              <div className="email-history-info">
                                <div className="email-history-subject">
                                  {email.subject || "No Subject"}
                                </div>

                                <div className="email-history-date">
                                  {email.createdAt
                                    ? new Date(email.createdAt).toLocaleString()
                                    : ""}
                                </div>
                              </div>
                            </div>

                            {email.toEmail && (
                              <div className="email-history-row">
                                <strong>To:</strong>
                                <span>{email.toEmail}</span>
                              </div>
                            )}

                            {email.ccEmail && (
                              <div className="email-history-row">
                                <strong>Cc:</strong>
                                <span>{email.ccEmail}</span>
                              </div>
                            )}

                            {email.message && (
                              <div className="email-history-message">
                                {email.message}
                              </div>
                            )}

                            {/* {email.uploadedFile && (
                              <a
                                href={email.uploadedFile}
                                target="_blank"
                                rel="noreferrer"
                                className="email-history-attachment"
                              >
                                <i className="fas fa-paperclip me-1"></i>
                                View Attachment
                              </a>
                            )} */}

                            {email.uploadedFile &&
                              !String(email.uploadedFile)
                                .trim()
                                .endsWith("/null") &&
                              !String(email.uploadedFile)
                                .trim()
                                .endsWith("/undefined") &&
                              String(email.uploadedFile).trim() !== "" && (
                                <a
                                  href={email.uploadedFile}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="email-history-attachment"
                                >
                                  <i className="fas fa-paperclip me-1"></i>
                                  View Attachment
                                </a>
                              )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="mt-4 w-100 text-center">
        <div className="row mx-0 justify-content-center">
          <div className="col-12 px-0">
            <span className="d-block">
              Copyright © 2024 <a href="/">FSHIP</a>. Developed by{" "}
              <a href="http://fship.in/">FSHIP</a>. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
